import React, { Component } from "react";
import FooterWidget from "./FooterWidget";
import { NavLink } from "react-router-dom";
import Social from "../Pages/Social.jsx";

class FooterSec extends Component {
  render() {
    return (
      <div>
        <div id="footer" style={{ background: "#111a28" }}>
          <div className="container">
            <div className="row py-5 widget-box">
              <div className="col-sm-6 col-lg-3 mt-4">
                <FooterWidget Heading="ঠিকানা">
                  <p>
                    <a href="javascript:void(0)">সেনবাগ, নোয়াখালি।</a>
                  </p>
                </FooterWidget>
              </div>
              <div className="col-sm-6 col-lg-3 mt-4">
                <FooterWidget Heading="যোগাযোগ">
                  <p>
                    <a href="javascript:void(0)">+৮৮-০১৬১০১৩৭৬৭৫</a>
                  </p>
                </FooterWidget>
              </div>
              <div className="col-sm-6 col-lg-3 mt-4">
                <FooterWidget Heading="পেইজ">
                  <p>
                    <NavLink exact to="/">
                      হোম
                    </NavLink>
                  </p>
                  <p>
                    <NavLink exact to="/about">
                      আমার সম্পর্কে
                    </NavLink>
                  </p>
                  <p>
                    <NavLink exact to="/skill">
                      দক্ষতা
                    </NavLink>
                  </p>
                  <p>
                    <NavLink exact to="/portfolio">
                      কাজসমুহ
                    </NavLink>
                  </p>
                  <p>
                    <NavLink exact to="/contact">
                      যোগাযোগ
                    </NavLink>
                  </p>
                  <p>
                    <NavLink exact to="/blog">
                      ব্লগ পড়ুন
                    </NavLink>
                  </p>
                </FooterWidget>
              </div>
              <div className="col-sm-6 col-lg-3 mt-4">
                <FooterWidget Heading="অনুসরণ করুন">
                  <Social firstChild="fa fa-facebook mx-0" />
                </FooterWidget>
              </div>
            </div>
          </div>
          <div className="border-bottom"></div>
          <div className="container py-4">
            <div className="copyright text-center text-white">
              সর্বস্বত্ব ফয়সাল দ্বারা সংরক্ষিত ২০২০-২০২১
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FooterSec;
